import { createAsyncThunk } from '@reduxjs/toolkit';
import { Profile } from '../models/profile';
import { GetProfileById } from './get-profile-by-id.thunk';
import { ProfilesDataState } from '../profiles-data.state';

export const SelectProfile = createAsyncThunk(
    'profilesData/selectProfile',
    async (id: string, { getState, dispatch }) => {
        const state = getState() as { profilesData: ProfilesDataState };
        const existingProfile = state.profilesData.profiles.find(
            (p) => p.id === id
        );

        if (existingProfile) {
            return existingProfile;
        }

        // If profile is not in state, fetch it
        const response = await dispatch(GetProfileById(id));
        return response.payload as Profile;
    }
);
